import React, { Component } from 'react';
import { connect } from 'react-redux';
import * as DataUtil from 'Flow2/components/CustomCollections/CustomDataUtil/CustomDataUtil';
import CustomTypes from 'Flow2/components/CustomCollections/CustomDataConfig/CustomDataTypes';
import * as actions from 'store/actions/index';
import './CustomHelpers.scss';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faUndo } from "@fortawesome/free-solid-svg-icons";
import { Link } from 'react-router-dom';


class CustomHelpers extends Component {


    displayContent = (el) => {
        if (el) {
            el.className = el.className.replace(/\bSidebarBlockCollapsed\b/g, "");
        }
    }

    handleWrapper = () => {
        if (this.props.type === "deletedItemsWrapper") {
            if (this.props.customFlexAppConfig.customDeletedWrapper) {
                let blockList = document.getElementsByClassName("SidebarBlockList");
                if (blockList) {
                    let parent = blockList[2];
                    this.displayContent(parent);
                }
                this.props.getCustomFlexAppConfig({ customDeletedWrapper: null })
            }
        }
    }

    showSelectedItem = (option) => {
        if (this.props.type === "deletedProjects" || this.props.type === "deletedRooms") {
            if (this.props.customFlexAppConfig.customCurrentDeletedItem && option) {
                const current = this.props.customFlexAppConfig.customCurrentDeletedItem;
                let deleted = document.getElementById(`${option}${current}`);
                if (deleted) {
                    deleted.style.background = "white";
                    let childOffset = deleted.offsetTop;
                    let parent = deleted.parentElement;
                    if (parent) {
                        this.displayContent(parent);
                        let parentOffset = parent.offsetTop;
                        parent.scrollTop = childOffset - parentOffset - 80;
                    }
                }
                this.props.getCustomFlexAppConfig({ customCurrentDeletedItem: null })
            }
        }
    }

    onBackBtnClick = () => {
        this.props.getCustomFlexAppConfig({ customCurrentDeletedItem: this.props.currentItem.id || null });
    }

    onWrapperClick = () => {
        this.props.getCustomFlexAppConfig({ customDeletedWrapper: this.props.currentItem.id || null });
    }

    isDeletedItem = () => DataUtil.getDeletedItem({
        elements: this.props.elements,
        currentItem: this.props.currentItem,
        deletedElements: this.props[`${this.props.type}`]
    });

    renderContent = () => {
        switch (this.props.type) {
            case "deletedItemsBackBtn":
                if (this.isDeletedItem())
                    return (<Link to="/deleteditems"><div className="CustomBackBox" onClick={this.onBackBtnClick}>
                        <FontAwesomeIcon style={CustomTypes.PAGE_ICON_COLOR} icon={faUndo} />
                    </div></Link>)
                return null;
            case "deletedItemsWrapper":
                return <span onClick={this.onWrapperClick}>{this.props.children}</span>;
            default:
                return (<div />);
        }
    }

    componentDidMount() {
        this.showSelectedItem(this.props.option);
        this.handleWrapper();
    }


    render() {
        return this.renderContent();
    }
}

const mapStateToProps = (state) => ({
    customFlexAppConfig: state.customData.customFlexAppConfig,
    deletedProjects: state.projects.deletedProjects,
    deletedRooms: state.rooms.deletedRooms,
})

const mapDispatchToProps = (dispatch) => ({
    getCustomFlexAppConfig: (option) => dispatch(actions.getCustomFlexAppConfig(option)),
})

export default connect(mapStateToProps, mapDispatchToProps)(CustomHelpers);